
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay_error",
      function () {
        return require("private-next-pages/pay_error.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay_error"])
      });
    }
  